export type CategoryKey = "all" | "movie" | "short" | "hot";

export type Category = {
  key: CategoryKey;
  name: string;
  shortName: string;
  description: string;
  icon: string;
  accent: string;
};

export const categories: Category[] = [
  {
    key: "all",
    name: "全部视频",
    shortName: "全部",
    description:
      "收录站点内全部电影、短片与热门视频内容，按收录时间与热度整理，便于一次性浏览。",
    icon: "ri-grid-fill",
    accent: "secondary",
  },
  {
    key: "movie",
    name: "电影",
    shortName: "电影",
    description:
      "收录剧情长片、类型电影与作者电影，覆盖华语、欧美、日韩等多个地区，可按年份与地区进一步筛选。",
    icon: "ri-film-line",
    accent: "primary",
  },
  {
    key: "short",
    name: "短片",
    shortName: "短片",
    description:
      "收录实验短片、动画短片、纪录短片与剧情短片，时长集中在十五分钟以内，适合短时间集中浏览。",
    icon: "ri-movie-2-line",
    accent: "accent",
  },
  {
    key: "hot",
    name: "热门",
    shortName: "热门",
    description:
      "近期浏览量增长最快的视频内容，包含人文纪录片、美食纪实与旅行观察等热门题材。",
    icon: "ri-fire-line",
    accent: "primary",
  },
];

export const regions: string[] = [
  "全部",
  "中国",
  "美国",
  "日本",
  "韩国",
  "英国",
  "法国",
];

export const years: string[] = [
  "全部",
  "2026",
  "2025",
  "2024",
  "2023",
  "2022",
];

export const sortOptions: { key: "latest" | "hot" | "rating"; label: string }[] = [
  { key: "latest", label: "最新收录" },
  { key: "hot", label: "最热浏览" },
  { key: "rating", label: "评分最高" },
];